import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(4)
  },
  rightBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginLeft: '30px'
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  label: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    color: '#8688A1',
    marginBottom: '4px'
  },
  tags: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer'
  },
  tag: {
    display: 'flex',
    flexDirection: 'column',
    width: '35%',
    padding: theme.spacing(1.5, 2),
    color: '#8688A1'
  },
  mostTag: {
    display: 'flex',
    flexDirection: 'column',
    width: '29%',
    borderRadius: '6px',
    backgroundColor: '#F7901E',
    color: '#FFFFFF',
    padding: theme.spacing(1.5, 2)
  },
  amount: {
    textAlign: 'center'
  },
  icon: {
    textAlign: 'center',
    margin: '4px 0'
  },
  name: {
    textAlign: 'center',
    textTransform: 'uppercase',
    minHeight: '26px'
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(5, 8)
  },
  header: {
    color: '#8688A1',
    marginBottom: '4px'
  },
  text: {
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '21px',
    color: '#8688A1',
    fontWeight: 'normal',
    textAlign: 'center'
  },
  content: {
    display: 'flex',
    padding: theme.spacing(5, 0),
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    position: 'relative'
  },
  contentLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    alignItems: 'flex-end',
    paddingRight: '10px',
    opacity: 0.1
  },
  contentRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingLeft: '10px',
    opacity: 0.1
  },
  faceIcon: {
    margin: '10px 0',
    zIndex: 1
  },
  valueRowLeft: {
    display: 'flex',
    alignItems: 'center',
    width: '80%',
    justifyContent: 'flex-end'
  },
  valueRowRight: {
    display: 'flex',
    alignItems: 'center',
    width: '80%'
  },
  valueLeft: {
    marginRight: '10px'
  },
  valueRight: {
    marginLeft: '10px'
  },
  bar: {
    height: 30,
    zIndex: 2
  },
  constructionStup: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    top: 0,
    color: '#8688A1'
  }
}))
